// extracted by mini-css-extract-plugin
export default {"cta":"mH-z","disabled":"nH-z"};